import i18next from 'i18next'
import moment from 'moment'
import { config } from '../config/config'

export async function prepareLocale(locale) {
    moment.locale(locale)

    try {
        const bundle = await import(`../locale/${locale}/${locale}`)

        return await new Promise((resolve, reject) => {
            i18next.init({
                lng: locale,
                debug: !config.isProduction,
                resources: {
                    en: locale === 'en' ? bundle.default : null,
                    ru: locale === 'ru' ? bundle.default : null
                }
            }, (err, t) => {
                if (err) {
                    console.error('i18next init error:', err)
                    reject(err)
                } else {
                    resolve(t)
                }
            })
        })
    } catch (error) {
        console.error('Error while importing locale bundle', error)
    }
}
